import { render, staticRenderFns } from "./FeatureCardData.vue?vue&type=template&id=1c9eee88&scoped=true&"
import script from "./FeatureCardData.vue?vue&type=script&lang=js&"
export * from "./FeatureCardData.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c9eee88",
  null
  
)

export default component.exports